import { Component, Input } from '@angular/core';
import { FleetVehicle, FLEET_STATUS_META } from '../../mock/models/fleet.models';

@Component({
  selector: 'app-vehicle-mini-card',
  templateUrl: './vehicle-mini-card.component.html',
  styleUrl: './vehicle-mini-card.component.css',
})
export class VehicleMiniCardComponent {
  @Input() vehicle: FleetVehicle | null = null;

  readonly statusMeta = FLEET_STATUS_META;

  get meta() {
    return this.vehicle ? this.statusMeta[this.vehicle.status_live] : null;
  }
}
